import { useRouter } from "next/router";
import { useEffect } from "react";

const cookieName = "wagmi.store";

const useLedgerCookies = () => {
  const router = useRouter();

  useEffect(() => {
    const wagmiStore = localStorage.getItem(cookieName)
      ? JSON.parse(localStorage.getItem(cookieName) || "")
      : null;

    if (
      router.query?.embed &&
      router.query?.address &&
      (!wagmiStore || !wagmiStore?.state?.data?.account)
    ) {
      localStorage.setItem(
        cookieName,
        JSON.stringify({
          state: {
            data: {
              account: router.query?.address,
              chain: { id: 1, unsupported: false },
            },
          },
          version: 2,
        })
      );
      router.reload();
    }
  }, [router.query]);

  return;
};

export default useLedgerCookies;
